"use client";

import { useSyncExternalStore } from "react";
import { EMPTY_SAVED, EXPLORE_STORAGE_KEY, readSavedDiscoveries } from "@/lib/explore";

let current = EMPTY_SAVED;
let raw: string | null | undefined;
let memoryOnly = false;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((listener) => listener());

function snapshot() {
  if (typeof window === "undefined" || memoryOnly) return current;
  try {
    const stored = localStorage.getItem(EXPLORE_STORAGE_KEY);
    if (stored !== raw) {
      raw = stored;
      try { current = readSavedDiscoveries(stored ? JSON.parse(stored) : null); }
      catch { current = []; }
    }
  } catch { /* Saving still works for this session when browser storage is unavailable. */ }
  return current;
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  const sync = (event: StorageEvent) => { if (event.key === EXPLORE_STORAGE_KEY || event.key === null) { raw = undefined; notify(); } };
  window.addEventListener("storage", sync);
  return () => { listeners.delete(listener); window.removeEventListener("storage", sync); };
}

export function toggleDiscovery(href: string) {
  const saved = snapshot();
  current = readSavedDiscoveries(saved.includes(href) ? saved.filter((item) => item !== href) : [...saved, href]);
  try { raw = JSON.stringify(current); localStorage.setItem(EXPLORE_STORAGE_KEY, raw); memoryOnly = false; }
  catch { memoryOnly = true; }
  notify();
}

export function useSavedDiscoveries() {
  return useSyncExternalStore(subscribe, snapshot, () => EMPTY_SAVED);
}
